import { PropsWithChildren } from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type ComponentProps = {
  error?: boolean;
  focus?: boolean;
  mb?: number;
};

type Props = ComponentProps & PropsWithChildren;

export const LabelText: React.FC<Props> = ({
  children,
  error = false,
  focus = false,
  mb,
}): JSX.Element => {
  const theme = useTheme();
  return (
    <Typography
      color={error ? 'error' : focus ? 'secondary' : theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'GrayText'}
      mb={mb}
      variant='caption'
      fontSize={20}
      fontWeight={error ? '500' : '300'}
    >
      {children}
    </Typography>
  );
};
